// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"d716b0ed","796":"1ed208bf"}[chunkId] + ".chunk.js";
};